import { UserSchema } from "mock/schemas"

const profilesArray = [
    ["Bertrand", "Martin", "bmartin", "bmartin@ortec.fr", "1", "1"],
    ["Béatrice", "Beauvau", "bbeauvau", "beatrice.beauvau@oreve.fr", "2", "2"],
]



const createProfileObject = (arr: string[]): UserSchema => {
    return {
        firstName: arr[0],
        lastName: arr[1],
        username: arr[2],
        email: arr[3],
        id: arr[4],
        entity_id: arr[5],
    }
}


export const profilesMockData: UserSchema[] = profilesArray.map((arr) =>
    createProfileObject(arr)
)